export default function consoleController(status, message) {
  if (process.env.NODE_ENV !== "production") {
    switch (status) {
      case "log":
        console.log(message);
        break;
      case "error":
        console.error(message);
        break;
      default:
    }
  }
}
